import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const remove = async (data: { _id: string }) => {
  const response: TServerResponse = await request({
    url: apiUrls.blogs.DELETE_BLOGS,
    method: "POST",
    data,
  });
  return response;
};

export const useRemoveBlogsMutation = () => {
  return useMutation({ mutationFn: remove });
};
